@if ({ collapsed: collapsed$ | async, activeListId: lookBookListIdInRouter$ |
async, lookbookIdInRoute: lookbookIdInRoute$ | async }; as observables) {
<atx-piled-media
  class="position-relative"
  [piled]="observables.collapsed"
  [class.expanded]="!observables.collapsed"
>
  @for (list of listReferences; track list; let i = $index) {
  <atx-media-preview
    [class.active]="
      list.id === observables.activeListId &&
      observables.lookbookIdInRoute === lookBookId
    "
    atxScrollIntoView
    [atxScrollDelay]="150"
    [atxScrollCondition]="
      list.id === observables.activeListId &&
      observables.lookbookIdInRoute === lookBookId
    "
    [media]="list.media"
    [startVideoAdvancedBy]="3"
    [activateOnMouseEnter]="true"
    [activateMedia]="false"
    [maxWidth]="imageSizes.XXXSMALL"
    [showPreviewMedia]="true"
    [videoAttributes]="{
      muted: true,
      controls: false,
      autoplay: false,
      disablePlaceholder: true
    }"
    (click)="
      stopEvent($event);
      collapseCommand$$.next(false);
      listIdClicked$$.next(list.id);
      setSource(list);
      referenceClicked.emit(list)
    "
    objectFit="cover"
  >
    @if (!observables.collapsed) {
    <div class="hot-icon position-absolute">
      <epc-hot-list-indicator [listId]="list.id"></epc-hot-list-indicator>
    </div>
    @if (isListCommercialList(list?.type)) {
    <epc-commercial-list-ribbon
      class="commercial-list-badge"
    ></epc-commercial-list-ribbon>
    } }
    <epc-spotlight-item-header [title]="list.name"></epc-spotlight-item-header>
  </atx-media-preview>
  }
</atx-piled-media>
@if (lookBookId) {
<div class="lookbook-title-wrapper">
  <div
    [attr.data-e2e]="'spotlight-' + article?.title"
    class="d-inline-flex align-items-center sticky"
  >
    <span class="lookbook-title pl-1 text-muted text-truncate">
      {{ article?.title }}
    </span>
    @if (!observables.collapsed) {
    <button
      class="btn btn-link collapse-button py-0"
      (click)="stopEvent($event); collapseCommand$$.next(true)"
      data-e2e="collapse-lookbook-button"
      i18n="
        LookBookSpotlightItem|Collapse button@@lookBookSpotLightItemCollapse"
    >
      Collapse
    </button>
    }
  </div>
</div>
} }
